// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Fja-z","beautyGrouping":"Gja-z","beautySwatches":"Hja-z","swatches":"Ija-z"};